import React from 'react';

const SplashScreen = () => {
    return (
        <div className="fixed inset-0 bg-brand-dark flex flex-col items-center justify-center p-6 text-center z-50">
            <div className="animate-fade-in space-y-6 max-w-lg">
                {/* Optional Logo Placeholder if needed, for now just text as requested */}
                {/* <div className="w-24 h-24 bg-gradient-accent rounded-full mx-auto mb-6 flex items-center justify-center">
            <span className="text-4xl font-bold text-white">CV</span>
        </div> */}

                <h1 className="text-2xl md:text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-brand-accent-pink to-brand-light-gray">
                    Christian Videos
                </h1>

                <p className="text-lg md:text-xl text-gray-300 font-medium leading-relaxed">
                    Streaming Platform for Inspirational Christian Content, Sermons, and Songs
                </p>

                {/* Subtle loading indicator at bottom */}
                <div className="flex justify-center mt-8">
                    <div className="flex space-x-2">
                        <div className="w-2 h-2 bg-brand-accent-pink rounded-full animate-bounce animation-delay-0"></div>
                        <div className="w-2 h-2 bg-brand-accent-pink rounded-full animate-bounce animation-delay-200"></div>
                        <div className="w-2 h-2 bg-brand-accent-pink rounded-full animate-bounce animation-delay-400"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SplashScreen;
